import isNumber from 'lodash/isNumber';

import { CertificateSettingsInput } from '@/types/schema';

export default function isInvalidCertificateSettings(
  certificateSettings?: CertificateSettingsInput | null,
) {
  if (!certificateSettings) {
    return false;
  }

  return isNumber(certificateSettings.minPercentage) && isNaN(certificateSettings.minPercentage);
}
